/** Trimmed, single-spaced and lower-cased, as the slash menu treats commands. */
function normalize(text: string) {
  return text.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
}

/**
 * 0 is best: the whole title, then a title prefix, then a prefix of a later
 * word, then a match anywhere.
 */
function rank(title: string, needle: string) {
  if (title === needle) return 0;
  if (title.startsWith(needle)) return 1;
  if (title.includes(` ${needle}`)) return 2;
  return 3;
}

/**
 * Filters templates by what was typed after `/template`. Every typed word has
 * to appear in the title, in any order, so `standup daily` finds
 * "Daily standup". The best match comes first because Enter picks the first
 * row; ties sort alphabetically. An empty argument lists everything.
 */
export function matchTemplates<T extends { title: string }>(
  templates: readonly T[],
  argument: string
): T[] {
  const needle = normalize(argument);
  const words = needle ? needle.split(' ') : [];
  return templates
    .map(template => ({ template, title: normalize(template.title) }))
    .filter(({ title }) => words.every(word => title.includes(word)))
    .map(entry => ({ ...entry, rank: needle ? rank(entry.title, needle) : 0 }))
    .sort((a, b) => a.rank - b.rank || a.title.localeCompare(b.title))
    .map(({ template }) => template);
}
